import { ProjectAboutFormData } from "@/components/project-registration/project-about/schema"
import { ProjectDetailsFormData } from "@/components/project-registration/project-details/schema"
import { ProjectViewFormData } from "@/components/project-registration/project-view/schema"
import { IUpdateProject } from "@/interfaces/project.interface"

export interface Project {
  id?: number
  title: string
  salic_number: string
  proponent: string
  cnpj_proponent: string
  release_date: string
  episode_count?: string
  episode_duration?: string
  segment?: string
  genre: string
  format?: string
  logline: string
  id_user?: number
}

export class ProjectAbout {
  id = 0
  name = ""
  salic_number = ""
  // proponent = ""
  // cnpj_proponent = ""
  release_date = ""
  number_of_episodes = 0
  time_per_episode = 0
  movie_segment = ""
  movie_genre = ""
  movie_format = ""
  logline = ""
  sanfom_number = ""
  dou_publication_date = ""

  static mapToProjectAbout(data: ProjectAboutFormData, id: number = 0) {
    const project = new ProjectAbout()
    project.id = id
    project.name = data.title || ""
    project.salic_number = data.salicNumber || ""
    project.release_date = data.releaseDate || ""
    project.number_of_episodes = Number(data.episodeCount) || 0
    project.time_per_episode = Number(data.episodeDuration) || 0
    project.movie_segment = data.segment || ""
    project.movie_genre = data.genre || ""
    project.movie_format = data.format || ""
    project.logline = data.logline || ""
    project.sanfom_number = "SANFOM123456"
    project.dou_publication_date = new Date(data.releaseDate).toISOString() || ""
    return project
  }
}

export class ProjectDetails {
  id = 0
  description = ""
  id_movie_status = ""
  protocol_number = ""
  id_state = ""
  id_country = ""
  movie_original_language = ""
  movie_time = ""
  budget = {
    amount: 0,
    total_amount: 0
  }

  static mapToProjectDetails(id: number, data: ProjectDetailsFormData): IUpdateProject {
    return {
      id: id,
      description: data.sinopse || "",
      // TODO: Backend - Add support for negociacao field
      // negociacao: data.negociacao || "",
      id_movie_status: Number(data.step) || 0,
      protocol_number: data.protocol || "",
      // TODO: Backend - Add support for janelas_exibicao field
      // janelas_exibicao: data.janelas_exibicao || "",
      id_state: getStateId(data.uf),
      id_country: 19, // Default to Brasil 
      movie_original_language: data.language || "",
      movie_time: Number(data.time) || 0,
      budget: {
        id_buget_step: 1,
        amount: Number(data.approvedValue) || 0,
        total_amount: Number(data.capturedValue) || 0
      }
    }
  }
}

function getStateId(stateName: string): number {
  const stateMap: Record<string, number> = {
    "Acre": 1,
    "Alagoas": 2,
    "Amapá": 3,
    "Amazonas": 4,
    "Bahia": 5,
    "Ceará": 6,
    "Distrito Federal": 7,
    "Espírito Santo": 8,
    "Goiás": 9,
    "Maranhão": 10,
    "Mato Grosso": 11,
    "Mato Grosso do Sul": 12,
    "Minas Gerais": 13,
    "Pará": 14,
    "Paraíba": 15,
    "Paraná": 16,
    "Pernambuco": 17,
    "Piauí": 18,
    "Rio de Janeiro": 19,
    "Rio Grande do Norte": 20,
    "Rio Grande do Sul": 21,
    "Rondônia": 22,
    "Roraima": 23,
    "Santa Catarina": 24,
    "São Paulo": 25,
    "Sergipe": 26,
    "Tocantins": 27
  };
  return stateMap[stateName] || 0;
}

export class ProjectView {
  id = 0
  media_kit_url = ""
  movie_teaser_url = ""
  cover_image = ""
  facebook = ""
  twitter = ""
  linkedin = ""
  instagram = ""

  static mapToProjectView(data: ProjectViewFormData, id: number = 0): IUpdateProject {
    return {
      id,
      media_kit_url: data.presentationMaterialsLink || "",
      movie_teaser_url: data.videoTeaserLink || ""
    }
  }
}